/* eslint-disable import/no-unresolved */
import classNames from "classnames";
import { withFormik } from "formik";
import moment from "moment";
import { arrayOf, bool, func, number, shape, string } from "prop-types";
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import { isIOS } from "react-device-detect";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { compose } from "redux";
import Yup from "yup";

import Button from "pages/_components/Button";
import ContextMenu from "pages/_components/ContextMenu";
import Head from "pages/_components/Head";
import I18n from "pages/_components/I18n";
import Notification from "pages/_components/Notification";
import PageLoading from "pages/_components/PageLoading";
import { resizableRoute } from "pages/_components/Resizable";
import Check from "pages/_components/fields/Checkbox";
import SelectedAccountsAmount from "pages/charges/_components/SelectedAccountsAmount";
import EcheqsList from "pages/checks/Echeqs/EcheqsList";
import MultipleEcheqsButtons from "pages/checks/Echeqs/MutipleEcheqsButtons";

import { actions, INITIAL_STATE, selectors, types } from "reducers/checks";
import { actions as notificationActions } from "reducers/notification";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as statusActions } from "reducers/status";
import { actions as transactionsActions, selectors as transactionsSelectors } from "reducers/transactions";
import { actions as globalActions } from "reducers/types/global";

import { Box, FormattedAmount, Separator, Text, ToggleButtonGroup } from "@ui-kit/components/index.es";
import { checkDisableMultiple, echeqShape } from "util/checks";
import * as configUtils from "util/config";
import { getLimitDate } from "util/date";
import { evalEqualsValues } from "util/form";
import * as i18n from "util/i18n";
import { saveLocation } from "util/transaction";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";
import { getPostLoginHomePath } from "util/v3UxConfig";
import { currencyMap } from "../../../constants";
import EcheqsFilters from "./EcheqsFilters";

const FORM_ID = "echeqs";

const ECHEQ_TERMINAL_ROUTE_PATTERNS = [
    /^\/echeqs\/(confirm|pending|failed|cancelled)\//,
    /^\/echeqs\/transaction\//,
    /^\/echeqs\/return\/accept\/transaction/,
    /^\/echeqs\/multiple\//,
    /^\/echeqs\/emitMassive\//,
];

const isEcheqTerminalRoute = (pathname) => {
    if (!pathname || typeof pathname !== "string") {
        return false;
    }
    return ECHEQ_TERMINAL_ROUTE_PATTERNS.some((rx) => rx.test(pathname));
};

class EcheqsMainPage extends Component {
    enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

    echeqUSDfuncionalites = configUtils.getBoolean("frontend.ECHEQsUSD.functionalities", false);

    currencyArray = ["032", "840"];

    static propTypes = {
        setSubmitting: func.isRequired,
        setValues: func.isRequired,
        isSubmitting: bool.isRequired,
        dispatch: func.isRequired,
        isMobile: bool.isRequired,
        isDesktop: bool.isRequired,
        isSmallDesktop: bool.isRequired,
        // eslint-disable-next-line react/no-unused-prop-types
        multipleSelection: bool.isRequired,
        values: shape({}).isRequired,
        option: string.isRequired,
        environmentCuit: string.isRequired,
        echeqsList: arrayOf(echeqShape).isRequired,
        fetchingEcheqsDownload: bool.isRequired,
        filters: shape({
            createdFrom: string.isRequired,
            createdTo: string.isRequired,
            payedFrom: string.isRequired,
            payedTo: string.isRequired,
            payedCheck: bool.isRequired,
            emitedCheck: bool.isRequired,
            receiver: string.isRequired,
            emitted: string.isRequired,
            status: shape({ value: string.isRequired, label: string.isRequired }).isRequired,
            number: arrayOf(string).isRequired,
            grouper: string.isRequired,
            id: arrayOf(string).isRequired,
            orderColumName: string.isRequired,
            orderDirection: string.isRequired,
        }).isRequired,
        echeqPagination: shape({
            extra_info: number.isRequired,
            estado: number.isRequired,
            pageNumber: number.isRequired,
        }).isRequired,
        handleSubmit: func.isRequired,
        configForm: shape({}).isRequired,
        history: shape({
            listen: func.isRequired,
        }).isRequired,
        activeEnvironment: shape({
            permissions: shape({
                emitEcheq: bool,
            }),
        }).isRequired,
        match: shape.isRequired,
        stateList: arrayOf(shape({})),
        accountsFetching: bool,
        serverSearchDate: string.isRequired,
        idSelectorError: bool.isRequired,
        numberSelectorError: bool.isRequired,
        showCleanFilterButton: bool,
        idFilter: arrayOf(
            shape({
                value: string,
            }),
        ).isRequired,
        numberFilter: arrayOf(
            shape({
                value: string,
            }),
        ).isRequired,
        filtersByOption: shape({}).isRequired,
        currency: string,
        embeddedInV3Shell: bool,
        lastTransactionRoute: string,
    };

    static defaultProps = {
        stateList: [],
        accountsFetching: false,
        currency: "032",
        showCleanFilterButton: false,
        embeddedInV3Shell: false,
        lastTransactionRoute: "",
    };

    state = {
        selectedRows: [],
        selectedAll: false,
        showForm: false,
        showSnackbarFiltred: false,
        width: 0,
        enabledEcheqMassive: false,
        isAvailableEcheqMassive: false,
        filterOrder: {
            column: "",
            direction: "",
        },
        changeFilterFunc: () => {},
        cleanFilter: false,
        activeHint: "",
        cleanupFilters: false,
    };

    componentDidMount() {
        const {
            dispatch,
            values,
            option,
            setSubmitting,
            filters,
            setValues,
            isDesktop,
            match,
            history,
            activeEnvironment,
            lastTransactionRoute,
        } = this.props;

        const { currency } = this.props;
        const initialEcheqFilters = INITIAL_STATE.echeqFilters;

        const isReturningFromTerminalScreen =
            isEcheqTerminalRoute(lastTransactionRoute) && lastTransactionRoute !== history?.location?.pathname;
        if (isReturningFromTerminalScreen) {
            dispatch(globalActions.resetSelectedElements());
        }

        saveLocation(this.props);
        dispatch(statusActions.saveLastHref(history.location));
        const baseFilters = isReturningFromTerminalScreen ? initialEcheqFilters : filters;
        let newFilters = baseFilters;
        let echeqType = isReturningFromTerminalScreen ? INITIAL_STATE.optionEcheq : option;
        if (match?.params?.echeqId) {
            echeqType = match?.params?.echeqType;
            newFilters = {
                ...newFilters,
                id: [match?.params?.echeqId],
                payedCheck: false,
                emitedCheck: false,
            };
        }
        if (match?.params?.state) {
            newFilters = {
                ...newFilters,
                status: match?.params?.state,
                payedCheck: false,
                emitedCheck: false,
            };
        }

        if (match?.params?.currency) {
            const currency2 = Object.keys(currencyMap).find((key) => currencyMap[key] === match.params.currency);
            dispatch(actions.setCurrencySelected(currency2));
        }

        newFilters = {
            ...newFilters,
            status:
                this.getSelectedOption() === "massive" && initialEcheqFilters.status === newFilters.status
                    ? "TODOS"
                    : newFilters.status,
        };

        const filtersEcheq = {
            ...values,
            pageNumber: 1,
            ...newFilters,
            option: echeqType,
            ...(this.echeqUSDfuncionalites ? { currency } : {}),
            ...(this.echeqUSDfuncionalites && match?.params?.echeqId
                ? {
                      currency: null,
                  }
                : {}),
        };
        const isAvailableEcheqMassive = configUtils.getBoolean("frontend.show.MassiveEcheq.functionalities", false);
        this.setState((prev) => ({
            ...prev,
            isAvailableEcheqMassive,
            enabledEcheqMassive: !!activeEnvironment.permissions?.massiveEmitEcheq && isAvailableEcheqMassive,
        }));

        setValues({ ...values, ...newFilters });
        setSubmitting(true);
        this.chargeConfig();
        dispatch(actions.cleanEcheqAction());
        dispatch(actions.setEcheqOption(echeqType));
        dispatch(actions.filterEcheqList(filtersEcheq, setSubmitting, isDesktop));
        dispatch(actions.setEcheqFilters(filtersEcheq, evalEqualsValues(initialEcheqFilters, baseFilters)));
        dispatch(actions.setGoBackEcheqs(false));
        dispatch(actions.setRememberMassiveData(false));
        dispatch(transactionsActions.saveTransactionRoute(history?.location?.pathname));

        if (isIOS) {
            window.scrollTo(0, 1);
        }
        window.addEventListener("resize", this.updateDimensions);
        this.applyV3ShellLayout();
        if (!this.enableRangeDatefield) {
            Promise.resolve().then(() => {
                const { setValues: applyFormValues, values: formValues, option: echeqOption } = this.props;
                this.resetDateValues(applyFormValues, formValues, echeqOption);
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.width !== window.innerWidth) {
            this.updateDimensions();
        }
        if (prevProps.isSubmitting && !prevProps.echeqsList?.length && isIOS) {
            window.scrollTo(0, 1);
        }
        this.checkForFilterChange();
        const {
            embeddedInV3Shell,
            isDesktop,
            option,
            isSubmitting,
            fetchingEcheqsDownload,
            activeEnvironment,
            values,
            setValues,
        } = this.props;
        const { enabledEcheqMassive } = this.state;
        if (
            prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
            prevProps.isDesktop !== isDesktop ||
            prevProps.option !== option ||
            prevProps.isSubmitting !== isSubmitting ||
            prevProps.fetchingEcheqsDownload !== fetchingEcheqsDownload ||
            prevProps.activeEnvironment?.permissions?.emitEcheq !== activeEnvironment?.permissions?.emitEcheq ||
            prevState.enabledEcheqMassive !== enabledEcheqMassive
        ) {
            this.applyV3ShellLayout();
        }
        if (!this.enableRangeDatefield && this.didEcheqDateOrCheckboxFieldsChange(prevProps.values, values)) {
            this.resetDateValues(setValues, values, option);
        }
    }

    componentWillUnmount() {
        const { dispatch, history, serverSearchDate, embeddedInV3Shell } = this.props;

        const nextPath = history?.location?.pathname || "";
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch, { nextPathname: nextPath });
        }

        this.validateUrl(nextPath);

        dispatch({
            type: types.SET_ECHEQ_LIST,
            listEcheqs: [],
            totalPages: 1,
            pageNumber: 1,
            serverDate: serverSearchDate,
        });

        if (nextPath && !nextPath.startsWith("/echeqs")) {
            dispatch(globalActions.resetSelectedElements());
        }
        window.removeEventListener("resize", this.updateDimensions);
    }

    applyV3ShellLayout = () => {
        const { embeddedInV3Shell, isDesktop, dispatch } = this.props;
        const home = getPostLoginHomePath(isUxDashboardImprovementsEnabled());
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["echeqsMainPage"],
            titleKey: "echeqs.operate.title",
            goBackPath: home,
            rightContentMobile: !isDesktop ? this.rightContent() : undefined,
        });
    };

    currencyOnChange = (currency) => {
        const { dispatch } = this.props;
        // Se resetea la opcion
        dispatch(actions.setEcheqOption("received.echeqs"));
        dispatch(actions.setCurrencySelected(currency));
        // Se limpian los fitros
        this.setState({ cleanupFilters: true });
    };

    checkForFilterChange = () => {
        const { dispatch, numberSelectorError, idSelectorError, showCleanFilterButton } = this.props;

        if (!showCleanFilterButton && (numberSelectorError || idSelectorError)) {
            dispatch(actions.setShowCleanFilterButton(true));
        }
    };

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    };

    validateUrl = (nextPath) => {
        const { dispatch } = this.props;
        const pattern = /.*\/echeqs\/(received|emitted)/;

        let configForm = null;

        if (pattern.test(nextPath)) {
            const { multipleSelection, selectedRows, selectedAll, showForm, showSnackbarFiltred } = this.state;
            configForm = {
                multipleSelection,
                selectedRows,
                selectedAll,
                showForm,
                showSnackbarFiltred,
            };
        }

        dispatch({
            type: types.SET_CONFIG_FORM,
            configForm,
        });
    };

    chargeConfig = () => {
        const { configForm } = this.props;

        if (configForm) {
            this.setState(configForm);
        }
    };

    getMaxSelectionLimit = () => {
        const configValue = configUtils.get("echeq.multiple.selection.max");
        if (!configValue || configValue.trim() === "" || configValue === "null" || configValue === "undefined") {
            return null; // Sin límite
        }
        const limit = parseInt(configValue, 10);
        return Number.isNaN(limit) || limit <= 0 ? null : limit;
    };

    isMaxSelectionReached = (currentCount) => {
        const maxLimit = this.getMaxSelectionLimit();
        return maxLimit !== null && currentCount >= maxLimit;
    };

    selectAll = (checked) => {
        const { echeqsList, environmentCuit, filters, dispatch } = this.props;
        const { selectedRows } = this.state;
        let listElements = checked ? selectedRows : [];
        let hasShownMaxWarning = false;

        if (checked) {
            for (let i = 0; i < echeqsList.length; i++) {
                const okToAdd = !checkDisableMultiple(echeqsList[i], environmentCuit, filters.status);
                const maxSelectedReached = this.isMaxSelectionReached(listElements.length);

                if (
                    okToAdd &&
                    !maxSelectedReached &&
                    !selectedRows.some((echeq) => echeq.cheque_id === echeqsList[i].cheque_id)
                ) {
                    listElements = [...listElements, echeqsList[i]];
                } else if (this.isMaxSelectionReached(listElements.length) && !hasShownMaxWarning) {
                    // Solo mostrar la notificación una vez
                    dispatch(
                        notificationActions.showNotification(i18n.get("echeq.multiple.selection.max"), "warning", [
                            "echeqsMainPage",
                        ]),
                    );
                    hasShownMaxWarning = true;
                }
            }
        }

        const maxLimit = this.getMaxSelectionLimit();
        const selectedAllValue =
            maxLimit === null ? checked : checked && this.isMaxSelectionReached(selectedRows.length);

        this.setState({
            selectedRows: listElements,
            selectedAll: selectedAllValue,
        });
    };

    addSelectedRow = (echeq) => {
        const { environmentCuit, filters, dispatch } = this.props;
        const { selectedRows } = this.state;
        const maxSelectedReached = this.isMaxSelectionReached(selectedRows.length);
        const alreadySelected = selectedRows.find((element) => element.cheque_id === echeq.cheque_id);
        const okToAdd = !checkDisableMultiple(echeq, environmentCuit, filters.status);

        if (okToAdd) {
            if (!alreadySelected && !maxSelectedReached) {
                this.setState({
                    selectedRows: [...selectedRows, echeq],
                    selectedAll: false,
                });
            } else if (!alreadySelected && maxSelectedReached) {
                dispatch(
                    notificationActions.showNotification(i18n.get("echeq.multiple.selection.max"), "warning", [
                        "echeqsMainPage",
                    ]),
                );
            }

            if (alreadySelected) {
                this.setState({
                    selectedRows: selectedRows.filter((element) => element.cheque_id !== echeq.cheque_id),
                    selectedAll: false,
                });
            }
        }
    };

    handleBack = () => {
        const { dispatch, embeddedInV3Shell } = this.props;
        const home = getPostLoginHomePath(isUxDashboardImprovementsEnabled());
        if (embeddedInV3Shell) {
            dispatch(push(home));
        } else {
            dispatch(push("/desktop"));
        }
    };

    multipleActionsButtons = () => {
        const { selectedRows } = this.state;
        const { environmentCuit, isDesktop, echeqsList } = this.props;
        const { currency } = this.props;
        return (
            <MultipleEcheqsButtons
                currency={currency}
                selectedRows={selectedRows}
                environmentCuit={environmentCuit}
                isDesktop={isDesktop}
                echeqsListTotal={echeqsList.length}
            />
        );
    };

    getSelectedOption = () => {
        const { option } = this.props;
        switch (option) {
            case "emitted.echeqs":
                return "emitted";
            case "received.echeqs":
                return "received";
            case "emitted.massive.echeq":
                return "massive";
            default:
                return "";
        }
    };

    emitEcheq = () => {
        const { dispatch } = this.props;
        const { currency } = this.props;
        dispatch(actions.cleanEcheqAction());
        if (this.echeqUSDfuncionalites) {
            dispatch(
                push({
                    pathname: "/echeqs/emit",
                    state: {
                        currency,
                    },
                }),
            );
        } else {
            dispatch(push("/echeqs/emit"));
        }
    };

    emitMassiveEcheq = () => {
        const { dispatch } = this.props;

        dispatch(actions.cleanEcheqAction());
        dispatch(push("/echeqs/emit/massive"));
    };

    handleExport = (format) => {
        const { dispatch, values, option, filters, echeqPagination } = this.props;
        const { pageNumber } = echeqPagination;
        const filtersEcheq = { ...values, ...filters, option, pageNumber, format };
        dispatch(actions.downloadEcheqList(filtersEcheq));
    };

    rightContent = () => {
        const {
            isDesktop,
            fetchingEcheqsDownload,
            isMobile,
            activeEnvironment,
            isSubmitting,
            option,
            accountsFetching,
        } = this.props;
        const { enabledEcheqMassive } = this.state;

        let itemActiveMultiple = [];

        if (enabledEcheqMassive && isMobile) {
            itemActiveMultiple = [
                {
                    label: "echeq.massive.emit",
                    onClick: this.emitMassiveEcheq,
                    icon: "MultiCheq",
                },
                ...itemActiveMultiple,
            ];
        }
        if (activeEnvironment.permissions.emitEcheq && isMobile) {
            itemActiveMultiple = [
                {
                    label: "echeq.emit",
                    onClick: this.emitEcheq,
                    icon: "EmitCheq",
                },
                ...itemActiveMultiple,
            ];
        }

        let menuItems = [
            {
                label: "global.download.file.xls",
                onClick: () => this.handleExport("xls"),
                icon: "SendDown",
            },
        ];

        if (
            option === "emitted.massive.echeq" &&
            configUtils.getBoolean("frontend.showReportesMVP3.funcionalities", false)
        ) {
            menuItems.push({
                label: "global.download.file.pdf",
                onClick: () => this.handleExport("pdf"),
                icon: "SendDown",
            });
        }

        if (itemActiveMultiple.length > 0) {
            menuItems = [...itemActiveMultiple, ...menuItems];
        }

        return (
            <>
                {isDesktop ? (
                    <div className="d-flex justify-content-end gap-2">
                        {activeEnvironment.permissions.emitEcheq && (
                            <Button
                                block
                                label="echeq.emit"
                                bsStyle="primary"
                                onClick={this.emitEcheq}
                                className="cmf-button-width text-capitalize"
                                image="images/echeq__emit-icon.svg"
                                imageStyle="mr-2"
                                disabled={accountsFetching}
                            />
                        )}
                        {enabledEcheqMassive && (
                            <Button
                                block
                                label="echeq.massive.emit"
                                bsStyle="outline"
                                onClick={this.emitMassiveEcheq}
                                className="cmf-button-width text-transform-none px-2"
                                image="images/echeq__emit-massive-icon.svg"
                                imageStyle="mr-2"
                            />
                        )}
                        {!enabledEcheqMassive && (
                            <Button
                                block
                                label="global.download"
                                loading={fetchingEcheqsDownload}
                                image="images/download.svg"
                                onClick={this.handleExport}
                                className="btn-outline cmf-button-width"
                                imageStyle="mr-2"
                                disabled={isSubmitting}
                            />
                        )}
                    </div>
                ) : (
                    undefined
                )}
                {(!isDesktop || enabledEcheqMassive) && (
                    <ContextMenu
                        isDesktop={isDesktop}
                        color={!isDesktop ? "white" : undefined}
                        buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                        items={menuItems}
                    />
                )}
            </>
        );
    };

    didEcheqDateOrCheckboxFieldsChange = (prevValues, nextValues) => {
        if (!prevValues || !nextValues) {
            return true;
        }
        const keys = ["payedCheck", "payedFrom", "payedTo", "emitedCheck", "createdFrom", "createdTo"];
        return keys.some((k) => prevValues[k] !== nextValues[k]);
    };

    resetDateValues = (setValues, values, option) => {
        let newValues = { ...values };
        let changeValue = false;
        if (!values.payedCheck && (values.payedFrom || values.payedTo)) {
            newValues = { ...newValues, payedFrom: null, payedTo: null };
            changeValue = true;
        } else if (values.payedCheck && (!values.payedFrom || !values.payedTo)) {
            if (option === "emitted.echeqs") {
                newValues = { ...newValues, payedFrom: getLimitDate(0), payedTo: getLimitDate(365) };
                changeValue = true;
            } else {
                newValues = { ...newValues, payedFrom: getLimitDate(0), payedTo: getLimitDate(7) };
                changeValue = true;
            }
        }
        if (!values.emitedCheck && (values.createdFrom || values.createdTo)) {
            newValues = { ...newValues, createdFrom: null, createdTo: null };
            changeValue = true;
        } else if (values.emitedCheck && (!values.createdFrom || !values.createdTo)) {
            if (option !== "received.echeqs") {
                newValues = { ...newValues, createdFrom: getLimitDate(-365), createdTo: getLimitDate(0) };
                changeValue = true;
            } else {
                newValues = { ...newValues, createdFrom: getLimitDate(-7), createdTo: getLimitDate(0) };
                changeValue = true;
            }
        }

        if (changeValue) {
            setValues({ ...newValues });
        }
    };

    getOptions = () => {
        const options = this.currencyArray.map((code) => ({
            value: code,
            label: `${i18n.get("accounts.new.account.currency.label")} ${i18n.get(`core.currency.label.${code}`)}`,
        }));
        return options;
    };

    renderToggleCurrency = () => {
        const { currency, match } = this.props;
        return (
            this.echeqUSDfuncionalites && (
                <ToggleButtonGroup
                    id="currencySelector"
                    name="currencySelector"
                    onChange={(currencySelected) => {
                        this.currencyOnChange(currencySelected);
                    }}
                    options={this.getOptions()}
                    defaultValue={
                        (match?.params?.currency &&
                            Object.keys(currencyMap).find((key) => currencyMap[key] === match?.params?.currency)) ||
                        currency
                    }
                />
            )
        );
    };

    renderHeader = () => {
        const { isDesktop, embeddedInV3Shell } = this.props;
        const title = "echeqs.operate.title";
        if (embeddedInV3Shell && !isDesktop) {
            return null;
        }
        if (isDesktop) {
            return (
                <>
                    <Head onBack={this.handleBack} />
                    <Head
                        title={title}
                        handleClickMessage="global.download"
                        centerContentClassName="justify-content-start"
                        rightContent={() => this.rightContent()}
                        headerClassName="mb-4">
                        {window.innerWidth > 1100 && <Box pl={8}>{this.renderToggleCurrency()}</Box>}
                    </Head>
                </>
            );
        }

        return (
            <>
                <Head
                    headerClassName="blue-main-header-mobile"
                    titleClassName="w-100 align-center"
                    onBack={this.handleBack}
                    title={title}
                    rightContent={() => this.rightContent()}
                />
            </>
        );
    };

    handleFilterOrder = (columns, directions, changeFilters) => {
        this.setState({
            filterOrder: {
                column: columns,
                direction: directions,
            },
            changeFilterFunc: changeFilters,
        });
    };

    allChecksAreChecked = () => {
        const { echeqsList, environmentCuit, filters } = this.props;
        const { selectedRows } = this.state;

        let allSelected = false;
        echeqsList.forEach((echeq) => {
            const isSelectable = !checkDisableMultiple(echeq, environmentCuit, filters.status);
            if (isSelectable) {
                allSelected = selectedRows.some((selectedEcheq) => selectedEcheq.cheque_id === echeq.cheque_id);
            }
        });

        return allSelected;
    };

    render() {
        const {
            dispatch,
            isDesktop,
            values,
            isSubmitting,
            setValues,
            option,
            setSubmitting,
            handleSubmit,
            isSmallDesktop,
            isMobile,
            echeqsList,
            stateList,
            numberSelectorError,
            idSelectorError,
            filters,
            idFilter,
            numberFilter,
            filtersByOption,
            showCleanFilterButton,
            embeddedInV3Shell,
        } = this.props;
        const { currency } = this.props;

        const {
            showForm,
            selectedAll,
            selectedRows,
            width,
            filterOrder,
            changeFilterFunc,
            cleanFilter,
            showSnackbarFiltred,
            enabledEcheqMassive,
            activeHint,
            cleanupFilters,
        } = this.state;

        const totalAmountSelected = selectedRows.reduce((acc, echeq) => {
            const amount = echeq.monto;
            return acc + (parseFloat(amount, 10) > 0 ? parseFloat(amount, 10) : 0);
        }, 0);

        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="echeqsMainPage" />}
                <div className={!isSmallDesktop && isDesktop && "mr-2"}>
                    <div className="admin-detail-head w-100 px-0 mb-0">{this.renderHeader()}</div>
                    <div className={classNames("w-100", { "d-flex justify-content-center py-3": !isDesktop })}>
                        {window.innerWidth <= 1100 && this.renderToggleCurrency()}
                    </div>
                    <EcheqsFilters
                        dispatch={dispatch}
                        values={values}
                        setValues={setValues}
                        handleSubmit={handleSubmit}
                        isSubmitting={isSubmitting}
                        setSubmitting={setSubmitting}
                        option={option}
                        showForm={showForm}
                        showSnackbarFiltred={showSnackbarFiltred}
                        setEcheqsState={(newValues) => this.setState((prev) => ({ ...prev, ...newValues }))}
                        selectAll={this.selectAll}
                        multipleSelection
                        enabledEcheqMassive={enabledEcheqMassive}
                        showCleanFilterButton={showCleanFilterButton}
                        stateList={stateList}
                        filterOrder={filterOrder}
                        changeFilterFunc={changeFilterFunc}
                        cleanFilter={cleanFilter}
                        width={width}
                        isSmallDesktop={isSmallDesktop}
                        isDesktop={isDesktop}
                        isMobile={isMobile}
                        idSelectorError={idSelectorError}
                        numberSelectorError={numberSelectorError}
                        activeHint={activeHint}
                        filters={filters}
                        currency={currency}
                        filtersByOption={filtersByOption}
                        embeddedInV3Shell={embeddedInV3Shell}
                        idFilter={typeof idFilter === "string" ? idFilter : idFilter.map((item) => item.value)}
                        numberFilter={
                            typeof numberFilter === "string" ? numberFilter : numberFilter.map((item) => item.value)
                        }
                        cleanupFilters={cleanupFilters}
                        setCleanupFilters={(value) => {
                            this.setState({ cleanupFilters: value });
                        }}
                    />
                    {!isDesktop && option === "received.echeqs" && !this.echeqUSDfuncionalites && (
                        <Col xs={12} className="justify-content-right flex">
                            <SelectedAccountsAmount
                                list={selectedRows}
                                isDesktop={isDesktop}
                                summaryView
                                className={!isDesktop && "align-right"}
                            />
                        </Col>
                    )}
                    {this.echeqUSDfuncionalites && option === "received.echeqs" && (
                        <Box column gap={10} w="100%" mt={4} pt={16} mb={20} px={!isDesktop ? 16 : 0}>
                            <Box column>
                                <Box align="center" gap={8}>
                                    <Text variant="bodyBold">
                                        {i18n.get("echeq.total.selected.amount", "Monto total (seleccionados):")}
                                    </Text>
                                    <FormattedAmount
                                        amount={totalAmountSelected}
                                        currency={i18n.get(`core.currency.label.${currency}`)}
                                        variant="bodyBold"
                                    />
                                </Box>
                                <Text variant="caption">
                                    {i18n.get("echeq.total.selected.quantity", "Operaciones seleccionadas:")}{" "}
                                    {selectedRows.length}
                                </Text>
                            </Box>
                            <Separator color="neutral-superlight" />
                        </Box>
                    )}
                    <PageLoading
                        className={classNames({ "screen-loader": !isDesktop, "line-loader": isDesktop })}
                        loading={isSubmitting && !(isMobile && echeqsList.length)}>
                        {option === "received.echeqs" && (
                            <Col xs={12} className="px-0">
                                <div className="px-0 pb-2 echeqs__select-actions-row w-100">
                                    <div className={width > 1200 ? "d-flex" : ""}>
                                        {echeqsList.length ? (
                                            <div className="d-flex align-items-center min-height-3">
                                                <Check
                                                    hideLabel
                                                    id="selectAll"
                                                    name="selectAll"
                                                    checked={this.allChecksAreChecked()}
                                                    onChange={(e) => this.selectAll(e.target.checked)}
                                                    formGroupClassName="d-flex"
                                                />
                                                <I18n component="span" id="echeqs.filters.selectAll.label" />
                                            </div>
                                        ) : (
                                            undefined
                                        )}
                                        {this.multipleActionsButtons()}
                                    </div>
                                    {isDesktop && !this.echeqUSDfuncionalites && (
                                        <div className="echeq__totals mt-0 pl-2">
                                            <SelectedAccountsAmount
                                                list={selectedRows}
                                                summaryView
                                                currency={currency}
                                            />
                                        </div>
                                    )}
                                </div>
                            </Col>
                        )}
                        <EcheqsList
                            isDesktop={isDesktop}
                            isSmallDesktop={isSmallDesktop}
                            setSubmitting={setSubmitting}
                            option={option}
                            multipleSelection
                            showForm={showForm}
                            selectedRows={selectedRows}
                            selectedAll={selectedAll}
                            addSelectedRow={this.addSelectedRow}
                            selectAll={this.selectAll}
                            unCheckSelectAll={() => this.setState({ selectedAll: false })}
                            getSelectedOption={this.getSelectedOption}
                            orderByData={this.handleFilterOrder}
                            currency={currency}
                        />
                    </PageLoading>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    option: selectors.getEcheqOption(state),
    echeqsList: selectors.getEcheqsList(state),
    environmentCuit: selectors.getEnvironmentCuit(state),
    filters: selectors.getEcheqFilters(state),
    filtersByOption: selectors.getEcheqFiltersByOptions(state),
    configForm: selectors.getConfigForm(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    fetchingEcheqsDownload: selectors.getFetchingEcheqList(state),
    echeqPagination: selectors.getEcheqsPagination(state),
    stateList: selectors.getStateList(state),
    serverSearchDate: selectors.getServerSearchDate(state),
    idSelectorError: selectors.getIdSelectorErrorState(state),
    numberSelectorError: selectors.getNumberSelectorErrorState(state),
    numberFilter: selectors.getNumberListSelector(state),
    idFilter: selectors.getIdListSelector(state),
    showCleanFilterButton: selectors.getShowCleanFilterButton(state),
    currency: selectors.getCurrencySelected(state),
    lastTransactionRoute: transactionsSelectors.getTransactionRoute(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: ({ filters }) => {
            const defaultCreatedFrom = getLimitDate(-7);
            const defaultCreatedTo = getLimitDate(0);
            const defaultPayedFrom = getLimitDate(0);
            const defaultPayedTo = getLimitDate(7);

            const createdFromDate = filters?.createdFrom
                ? moment(filters.createdFrom).toDate()
                : defaultCreatedFrom.toDate();
            const createdToDate = filters?.createdTo ? moment(filters.createdTo).toDate() : defaultCreatedTo.toDate();
            const payedFromDate = filters?.payedFrom ? moment(filters.payedFrom).toDate() : defaultPayedFrom.toDate();
            const payedToDate = filters?.payedTo ? moment(filters.payedTo).toDate() : defaultPayedTo.toDate();

            return {
                createdFrom: defaultCreatedFrom,
                createdTo: defaultCreatedTo,
                createdDates: [createdFromDate, createdToDate],
                payedFrom: defaultPayedFrom,
                payedTo: defaultPayedTo,
                payedDates: [payedFromDate, payedToDate],
                payedCheck: true,
                emitedCheck: true,
                receiver: "",
                emitted: "",
                number: filters?.number || [],
                grouper: "",
                id: [],
                status: filters?.status || "TODOS",
                ownership: "TODOS",
                action: "all",
            };
        },
        validationSchema: ({ option }) =>
            Yup.lazy((values) => {
                const enableRangeDatefield = configUtils.getBoolean(
                    "frontend.show.RangeDatePicker.functionalities",
                    false,
                );
                let validationObject = {
                    amountFrom: values.amountTo
                        ? Yup.number().max(values.amountTo, i18n.get(`${FORM_ID}.amount.amountFrom.error`))
                        : Yup.number().nullable(),
                    amountTo: values.amountFrom
                        ? Yup.number().min(values.amountFrom, i18n.get(`${FORM_ID}.amount.amountTo.error`))
                        : Yup.number().nullable(),
                };
                if (!enableRangeDatefield) {
                    if (values.emitedCheck) {
                        validationObject = {
                            ...validationObject,
                            createdFrom: Yup.string()
                                .nullable()
                                .required(i18n.get("accounts.new.account.field.error.required")),
                            createdTo: Yup.string()
                                .nullable()
                                .required(i18n.get("accounts.new.account.field.error.required")),
                        };
                    }
                    if (values.payedCheck) {
                        validationObject = {
                            ...validationObject,
                            payedFrom: Yup.string()
                                .nullable()
                                .required(i18n.get("accounts.new.account.field.error.required")),
                            payedTo: Yup.string()
                                .nullable()
                                .required(i18n.get("accounts.new.account.field.error.required")),
                        };
                    }
                } else if (option === "emitted.massive.echeq") {
                    validationObject = {
                        ...validationObject,
                        createdDates: Yup.mixed().test(
                            "dates",
                            i18n.get(`${FORM_ID}.massive.validation.range.date`),
                            ([from, to]) => from && to,
                        ),
                    };
                }
                return Yup.object().shape(validationObject);
            }),
        handleSubmit: (formFilters, formikBag) => {
            const { dispatch, option, filters, isDesktop, idFilter, numberFilter } = formikBag.props;
            const { setSubmitting, setValues } = formikBag;
            const { orderColumName, orderDirection, currency } = filters;
            const nrsIdsFiltersEnabled = configUtils.getBoolean("FilterEcheqs.NrsIds.functionalities", false);
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
            let additionalFilters;
            if (nrsIdsFiltersEnabled) {
                additionalFilters = {
                    id: idFilter.map((item) => item.value),
                    ...(option !== "emitted.massive.echeq"
                        ? { number: numberFilter.map((item) => item.value) }
                        : { number: typeof formFilters.number === "string" ? [formFilters.number] : [] }),
                };
            } else {
                additionalFilters = {
                    id: typeof formFilters.id === "string" ? [formFilters.id] : [],
                    number: typeof formFilters.number === "string" ? [formFilters.number] : [],
                };
            }
            if (enableRangeDatefield) {
                setValues({
                    ...formFilters,
                    ...(formFilters.createdDates[0] && !formFilters.createdDates[1] && { createdDates: [null, null] }),
                    ...(option !== "emitted.massive.echeq" &&
                        formFilters.payedDates[0] &&
                        !formFilters.payedDates[1] && { payedDates: [null, null] }),
                });
            }

            const filter = {
                ...formFilters,
                ...(enableRangeDatefield && {
                    emitedCheck: formFilters.createdDates.every((d) => d),
                    createdFrom:
                        formFilters.createdDates[0] && formFilters.createdDates[1] ? formFilters.createdDates[0] : null,
                    createdTo: formFilters.createdDates[1],
                    ...(option !== "emitted.massive.echeq" && {
                        payedCheck: formFilters.payedDates.every((d) => d),
                        payedFrom:
                            formFilters.payedDates[0] && formFilters.payedDates[1] ? formFilters.payedDates[0] : null,
                        payedTo: formFilters.payedDates[1],
                    }),
                }),
                orderColumName,
                orderDirection,
                currency,
                option,
                status: formFilters.status,
                pageNumber: 1,
                ...additionalFilters,
            };

            dispatch(actions.setEcheqFilters(filter));
            dispatch(actions.setShowCleanFilterButton(true));
            dispatch(actions.filterEcheqList(filter, setSubmitting, isDesktop));
        },
    }),
    resizableRoute,
)(EcheqsMainPage);
